import { CalculationInfo } from '~/app/compositions/content/calculation-info';
import { ConfigurationOverview } from '~/app/compositions/content/configuration-overview';
import { ConsumptionAndEmissionText } from '~/app/compositions/content/consumption-and-emission-text/consumption-emission-text';
import { AccessoriesAndEquipments } from '~/app/compositions/sidebar/accessories-equiptments/accessories-equipment-step';
import EquipmentPackages from '~/app/compositions/sidebar/equimpent-packages/core/equipment-packages';
import { EquipmentHighlights } from '~/app/compositions/sidebar/equipment-highlights';
import { Headlights } from '~/app/compositions/sidebar/headlights';
import { Interior } from '~/app/compositions/sidebar/interior';
import InteriorPackages from '~/app/compositions/sidebar/interior-packages/interior-packages';
import { Packages } from '~/app/compositions/sidebar/package';
import { Paint } from '~/app/compositions/sidebar/paint';
import { Rims } from '~/app/compositions/sidebar/rims';
import { SteeringWheels } from '~/app/compositions/sidebar/steering-wheels';
import { TrimLine } from '~/app/compositions/sidebar/trim-line';
import { CarConfiUiConfiguration } from '~/app/market-config/models/car-confi-ui-configuration';
import { ImageViewsEnum } from '~/app/pages/configurator/models/image-views';
import { useConfigurator } from '~/graphql/hooks/use-configurator';

export default function DefaultMarketUI() {
	const {
		catalog: { accessoriesExclusive, accessoriesInclusive },
	} = useConfigurator();
	const uiConfi: CarConfiUiConfiguration = {
		options: {
			trimLine: () => {
				return {
					id: 'trim-line',
					label: 'ngc.equipment.trimlineAndEngine',
					imageView: ImageViewsEnum.EXTERIOR_FRONT_FRONT,
					component: <TrimLine />,
					camera: 'MRV6',
					visible: true,
				};
			},
			packages: () => {
				return {
					id: 'packages',
					label: 'ngc.equipment.packages',
					imageView: ImageViewsEnum.LIGHTS_FRONT_HEADLIGHTS,
					component: <Packages />,
					camera: 'MRV1',
					visible: true,
				};
			},
			steeringWheels: () => {
				return {
					id: 'steering-wheels',
					label: 'ngc.equipment.steeringWheels',
					imageView: ImageViewsEnum.INTERIOR_DASHBOARD_DASHBOARD,
					component: <SteeringWheels />,
					camera: 'Interior',
					visible: true,
				};
			},
			paint: (props) => {
				return {
					id: 'paint',
					label: 'ngc.equipment.bodyPaintFinishes',
					imageView: ImageViewsEnum.EXTERIOR_PARALLEL_SIDE,
					component: <Paint {...props} />,
					camera: 'MRV4',
					visible: true,
				};
			},
			headlights: () => {
				return {
					id: 'headlights',
					label: 'ngc.equipment.headlights',
					imageView: ImageViewsEnum.LIGHTS_FRONT_HEADLIGHTS,
					component: <Headlights />,
					camera: 'FrontRightShare',
					visible: true,
				};
			},
			rims: () => {
				return {
					id: 'rims',
					label: 'ngc.equipment.rims',
					imageView: ImageViewsEnum.EXTERIOR_WHEELS_RIM,
					component: <Rims />,
					camera: 'Rims',
					visible: true,
				};
			},
			interior: (props) => {
				return {
					id: 'interior',
					label: 'ngc.equipment.interior',
					imageView: ImageViewsEnum.INTERIOR_SEATS_SEATS,
					component: <Interior {...props} />,
					camera: 'Interior_Rear_View_RHD',
					visible: true,
				};
			},

			equipmentHighlights: () => {
				return {
					id: 'equipment-highlights',
					imageView: ImageViewsEnum.EXTERIOR_FRONT_FRONT,
					label: 'ngc.equipment.trimlineAndEngine',
					component: <EquipmentHighlights />,
					camera: 'MRVSide',
					visible: true,
				};
			},
			equipmentPackages: () => {
				return {
					id: 'equipment-packages',
					imageView: ImageViewsEnum.EXTERIOR_FRONT_3_4,
					label: 'ngc.equipment.equipmentPackages',
					component: <EquipmentPackages />,
					camera: 'MRVSide',
					visible: true,
				};
			},
			interiorPackages: () => {
				return {
					id: 'interior-packages',
					imageView: ImageViewsEnum.INTERIOR_SEATS_SEATS,
					label: 'ngc.equipment.interiorPackages',
					component: <InteriorPackages />,
					camera: 'Interior_Rear_View',
					visible: true,
				};
			},
			accessoriesAndEquipments: () => {
				return {
					id: 'accessories-and-equipments',
					label: 'ngc.equipmentAndAccessories.headline',
					imageView: ImageViewsEnum.EXTERIOR_FRONT_3_4,
					component: <AccessoriesAndEquipments />,
					camera: 'DefaultCamera',
					visible: true,
				};
			},
		},
		calculationInfoComponent: <CalculationInfo className="calculation" />,
		configOverviewComponent: <ConfigurationOverview />,
		consumptionAndEmissionSummary: <ConsumptionAndEmissionText />,
		showAccessoriesInclusive: true,
		showAccessoriesExclusive: true,
		accessoriesInclusive: accessoriesInclusive ?? [],
		accessoriesExclusive: accessoriesExclusive ?? [],
	};

	return uiConfi;
}
